// Utility functions


/*
 *
 * Fn to check if nested object has properties
 * @param {Object} obj - Object to check
 * @params {String} props - Properties to check
 * 
 * usage: _eval(obj, 'level1', 'level2', 'level3');
 */
export const _eval = (obj, ...props) => {
    for (const prop of props) {
        if (!obj || !Object.prototype.hasOwnProperty.call(obj, prop)) {
            return false;
        }
        obj = obj[prop];
    }
    return true;
}

/*
 *
 * Fn to change type of booleans stored as string variable
 * to expected correct boolean type 
 */

export const _bool = (value) => {
    if (value === 'true') return true
    if (value === 'false') return false
    return value
}


/*
 *
 * Is valid URL 
 */
export const isUrl = string => {
    try { return Boolean(new URL(string)); }
    catch (e) { return false; }
}

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export const isObject = item => {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export const mergeDeep = (target, ...sources) => {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} });
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }

    return mergeDeep(target, ...sources);
}


/*
 *
 * Fn to update a nested object propertie 
 * from string path
 * @param {Object} obj - Object to update
 * @params {String} path - Path to update
 * @params {String} value - Value to update
 * @returns {Object} - Updated object
 * 
 * Example:
 * const obj = { a: { b: { c: 3 } } };
 * updateNestedObject(obj, 'a.b.c', 4); // { a: { b: { c: 4 } } }
 */

export const updateNestedObject = (obj, path, value) => {
    const keys = path.split('.');
    let nestedObj = obj;
    for (let i = 0; i < keys.length - 1; i++) {
        nestedObj = nestedObj[keys[i]];
    }
    nestedObj[keys[keys.length - 1]] = value;
    return obj;
};